// To replace strings into a unified types. 防止coder在别的文件里面写错string

export enum ActionType {
  GET_MSG = "getMsg",
  GET_LIST = "getList",
  GET_NAME = "getName",
  GET_BACKEND_DATA = "getBackendData", // test

  IS_SHOW_PREDICTION_GRAPH = 'isShowPredictionGraph',
  IS_SHOW_HISTORICAL_GRAPH = 'isShowHistoricalGraph',
  UPDATE_HIGHLGHTEED_GRANT_FIELD_ID = 'updateHighlghtedGrantFieldID',

  UPDATE_MAINVIEW_GRAPH_DIV_SIZE = 'updateMainViewGraphDivSize',

  ONCLICK_IMPACT_FIELD_NODE = 'onClickImpactFieldNode',

  UPDATE_IS_INITIALIZE_BUBBLE_TREEMAP_FINISHED = 'updateIsInitializeBubbleTreemapFinished',
  UPDATE_IS_OPTIMIZED_BUBBLE_TREEMAP_FINISHED = 'updateIsOptimizedBubbleTreemapFinished',

  UPDATE_BUBBLE_TREEMAP_GEOMETRY_GROUP = 'updateBubbleTreemapGeometryGroup',
  UPDATE_BUBBLE_TREEMAP_ENTITY_GROUP_LIST = 'updateBubbleTreemapEntityGroupList',
  UPDATE_BUBBLE_TREEMAP_CIRCUMSCRIBED_RADII_DICT = 'updateBubbleTreemapCircumscribedRadiiDict',

  IS_SHOW_LEAF_NODE = "isShowLeafNode",
  UPDATE_FIELD_LEVEL_RANGE = 'updateFieldLevelRange',
  UPDATE_CONTEXT_MENU_IMPACT_ENTITY = "updateContextMenuImpactEntity",
  UPDATE_CONTEXT_MENU_POSITION = "updateContextMenuPosition",
  IS_SHOW_CONTEXT_MENU = "isShowContextMenu",
  UPDATE_LEAF_NODE_SIZE_SCALE = "updateLeafNodeSizeScale",
  UPDATE_LEAF_NODE_SIZE_SCALE_FOR_HIGHLIGHTED_GRANT_FIELD = 'updateLeafNodeSizeScaleForHighlightedGrantField',
  UPDATE_PREDICTION_GRANTIDLIST_4_PI_VIEW = "updatePredictionGrantIDList4PIView",
  UPDATE_WORDLE_ENTITY = 'updateWordleEntity',
  UPDATE_WORDLE_POSITION = 'updateWordPosition',
  IS_SHOW_WORDLE = "isShowWordle",
  UPDATE_SELECTED_IMPACT_ENTITY_FIELD = "updateSelectedEntityField",
  IS_SHOW_PREDICTION_FLOW = 'isShowPredictionFlow',
  IS_SHOW_HISTORICAL_FLOW = 'isShowHistoricalFlow',
  UPDATE_PREDICTION_SEARCH_RESULT = 'updatePredictionSearchResult',
  CLEAN_MAINVIEW_GRAPH = 'cleanMainviewGraph',

  GET_MAINVIEW_DATA = 'getMainViewData',
  GET_MAINVIEW_IMPACT_SUMMARY_TABLE_DATA = 'getMainViewImpactSummaryTableData',
  GET_MAINVIEW_LAYOUT_OPTIMIZATION_PARAMS = 'getMainViewLayoutOptimizationParams',
  IS_OPTIMIZING_MAINVIEW_LAYOUT_FINISHED = 'isOptimizingMainViewLayoutFinished',
  UPDATE_GRANT_FIELD_NODE_POSITION = 'updateGrantFieldNodePosition',
  UPDATE_CITATION_FLOW_TYPE = 'updateCitationFlowType',
  UPDATE_IMPACT_TYPE = 'updateImpactType',
  UPDATE_GRANT_GLYPH_TYPE = 'updateGrantGlyphType',
  UPDATE_TOP_K_FIELD = 'updateTopKField',
  UPDATE_TOP_K_CITATION_FLOW = 'updateTopKCitationFlow',
  ONCLICK_GRANT_FIELD_NODE = 'onClickGrantFieldNode',
  UPDATE_ENTITY_FIELD_GRAPH_INPUT_DATA = 'updateEntityFieldGraph_InputData',
  UPDATE_ENTITY_FIELD_GRAPH_NODE_LINK_DATA = 'updateEntityFieldGraph_NodeLinkData',
  UPDATE_LEAF_NODE_POSITION_LIST = 'updateLeafNodePositionList',
  UPDATE_LEAF_NODE_INITIAL_POSITION_LIST = 'updateLeafNodeInitialPositionList',
  UPDATE_NODE_POSITION_LIST = 'updateNodePositionList',
  UPDATE_IS_ENTITY_FIELD_GRAPH_FINISHED = 'updateIsEntityFieldGraphFinished',
  UPDATE_IS_ENTITY_TYPE_GRAPH_FINISHED = 'updateIsEntityTypeGraphFinished',
  UPDATE_ENTITY_TYPE_LAYOUT_DATA = 'updateEntityTypeLayoutData',

  GET_GRANT_ID_LIST = 'getGrantIdList',
  GET_GRANT_VIEW_DATA = 'getGrantViewData',
  GET_GRANT_VIEW_FIELD_SUBVIEW_DATA = 'getGrantViewFieldSubviewData',
  GET_PI_VIEW_DATA = 'getPIViewData',
  GET_PI_VIEW_CARD_LIST_DATA = 'getPIViewCardListData',
  GET_PI_VIEW_PREDICTED_CARD_LIST_DATA = 'getPIViewPredictedCardListData',
  GET_IMPACT_STATISTICS_VIEW_DATA = 'getImpactStatisticsViewData',
  GET_IMPACT_ENTITY_VIEW_DATA = 'getImpactEntityData',
  SET_SELECTED_GRANT_TOPIC_LIST = 'setSelectedGrantTopicList',
  GET_GRANT_ID_LIST_USING_GRANT_FIELD = 'getGrantIdListUsingGrantField',
  UPDATE_IMPACT_STATISTICS_TYPE_LIST = 'updateImpactStatisticsTypeList',

  GET_IMPACT_ENTITY_VIEW_DIRECT_PAPER_DATA = 'getImpactEntityViewDirectPaperData',
  GET_IMPACT_ENTITY_VIEW_DIRECT_PATENT_DATA = 'getImpactEntityViewDirectPatentData',
  GET_IMPACT_ENTITY_VIEW_DIRECT_CLINICAL_TRIAL_DATA = 'getImpactEntityViewDirectClinicalTrialData',
  GET_IMPACT_ENTITY_VIEW_DIRECT_CLINICAL_TRIAL_TYPE_DATA = 'getImpactEntityViewDirectClinicalTrialTypeData',
  GET_IMPACT_ENTITY_VIEW_INDIRECT_PATENT_DATA = 'getImpactEntityViewIndirectPatentData',
  GET_IMPACT_ENTITY_VIEW_INDIRECT_CLINICAL_TRIAL_DATA = 'getImpactEntityViewIndirectClinicalTrialData',
  GET_IMPACT_ENTITY_VIEW_INDIRECT_CLINICAL_TRIAL_TYPE_DATA = 'getImpactEntityViewIndirectClinicalTrialTypeData',
  GET_IMPACT_ENTITY_VIEW_INDIRECT_POLICY_DATA = 'getImpactEntityViewIndirectPolicyData',
  GET_IMPACT_ENTITY_VIEW_INDIRECT_POLICY_SOURCE_COUNTRY_DATA = 'getImpactEntityViewIndirectPolicySourceCountryData',
  GET_IMPACT_ENTITY_VIEW_INDIRECT_POLICY_SOURCE_TITLE_DATA = 'getImpactEntityViewIndirectPolicySourceTitleData',
  GET_IMPACT_ENTITY_VIEW_INDIRECT_NEWSFEED_DATA = 'getImpactEntityViewIndirectNewsfeedData',

  SEARCH_IMPACT_ENTITY_VIEW_PAPER_DATA = 'searchImpactEntityViewPaperData',
  SEARCH_IMPACT_ENTITY_VIEW_PATENT_DATA = 'searchImpactEntityViewPatentData',
  SEARCH_IMPACT_ENTITY_VIEW_CLINICAL_TRIAL_DATA = 'searchImpactEntityViewClinicalTrialData',
  SEARCH_IMPACT_ENTITY_VIEW_POLICY_DATA = 'searchImpactEntityViewPolicyData',
  // SEARCH_IMPACT_ENTITY_VIEW_INDIRECT_NEWSFEED_DATA = 'searchImpactEntityViewIndirectNewsfeedData',

  // UI related
  SET_QUERY_VIEW_FOLDED = 'setQueryViewFolded',
  CLEAR_CHECKBOX_SELECTION = 'clearCheckboxSelection',
  SET_CONTEXT_MENU_VISIBILITY_AND_POSITION = 'setContextMenuVisibilityAndPosition',
  SET_SHOW_ENTITY_TYPE_LEVEL_GRAPH = 'setShowEntityTypeLevelGraph',
  SET_SHOW_ENTITY_FIELD_LEVEL_GRAPH = 'setShowEntityFieldLevelGraph',

  // loading related
  UPDATE_RESEARCHER_OVERVIEW_LOADING = 'updateResearcherOverviewLoading',
  UPDATE_GRANT_VIEW_LOADING = 'updateGrantViewLoading',
  UPDATE_PI_VIEW_LOADING = 'updatePIViewLoading',
  UPDATE_IMPACT_ENTITY_VIEW_LOADING = 'updateImpactEntityViewLoading',
  UPDATE_IMPACT_STATISRICS_VIEW_LOADING = 'updateImpactStatisticsViewLoading',
  UPDATE_MAIN_VIEW_LOADING = 'updateMainViewLoading',
  UPDATE_MAIN_VIEW_LOADING_LABEL = 'updateMainViewLoadingLabel', // for streaming output progress manager

  // --- user management ---
  PERFORM_LOGIN = 'performLogin',
  PERFORM_REGISTER = 'performRegister',
  PERFORM_DELETE_ACCOUNT = 'performDeleteAccount',
  PERFORM_FORGET_PASSWORD = 'performForgetPassword',
  PERFORM_RESET_PASSWORD = "performResetPassword",
  PERFORM_VERIFY_EMAIL = "performVerifyEmail",
}